export const heading1 = 'font-poppins text-[4rem] font-600';

export const heading2 = 'font-rubik text-[2rem] font-600';

export const heading3 = 'font-rubik text-[1.75rem] font-600';

export const buttonText = 'font-poppins text-[1rem] font-600';

export const subheading1 = 'font-rubik text-[1.5rem]';

export const subheading2 = 'font-rubik text-[1.25rem]';

export const linkText = 'font-rubik text-[1rem] font-400 underline';

export const bodyTextLarge = 'text-[1.125rem] font-rubik font-400';

export const bodyText = 'text-[1rem] font-rubik font-400';

export const bodyTextSmall = 'text-[0.875rem] font-rubik font-400';

export const bodyTextSmallest = 'text-[0.75rem] font-rubik font-400';

export const card =
  'rounded-xl bg-base-100 border border-neutral-content shadow-default p-3.5';

export const secondaryInput =
  'relative rounded-lg bg-base-100 border border-neutral-content py-1 px-2 text-[0.875rem] focus-within:border-primary';

export const secondaryTextArea =
  'relative rounded-lg bg-base-100 border border-neutral-content py-1 text-[0.875rem] focus-within:border-primary';
